import { createSlice } from '@reduxjs/toolkit';
import FileInfo from '../../sdk/containers/FileInfo';
import { retrieveFileInfo } from '../../sdk/apis';

export const viewerSlice = createSlice({
  name: 'viewer',
  initialState: {
    folders: {},
  },
  reducers: {
    setFolders: (state, action) => {
      state.folders = action.payload;
    },
  }
});

export const { setFolders } = viewerSlice.actions;

export function addFolder(folder: FileInfo) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    const s = getState();
    const folders = Object.create(s.viewer.folders);

    if (folder.id in folders) { return; }

    folders[folder.id] = folder;
    dispatch(setFolders(folders));
  }
}

export function loadFolder(folderId: number) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    const s = getState();
    const folders = Object.create(s.viewer.folders);

    retrieveFileInfo(folderId).then((folder: FileInfo) => {
      folders[folder.id] = folder;
      dispatch(setFolders(folders));
    });
  }
}

export default viewerSlice.reducer
